import React, { useEffect, useState } from "react";
import {
    Button,
    Checkbox,
    FormControlLabel,
    InputBase,
    Grid, Typography
} from "@material-ui/core";
import SearchGrid from "../../../../../components/table/SearchGrid";
import useStyles from "./styles";
import { withSnackbar } from "../../../../../components/Message/Alert";
import { useHistory } from "react-router-dom";
import Loader from "../../../../../components/Loader/Loader";

import { PostDataAPI } from '../../../../../Services/APIService';
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
//import DisbursementIcon from "../../../../../assets/img/icons/disbursement.svg";
import Authorization from "./components/Authorization/Authorization";
import AddDisbursement from "./components/addDisbursement/AddDisbursement";
import { ActionDialog } from "../../../../../components/ActionDialog/ActionDialog";
import DisbursementDetail from "./components/viewDetails/ViewDetails";
import ClearIcon from '@material-ui/icons/Clear';
function Payment({ ...props }) {
    const classes = useStyles();
    const { showMessage } = props;

    let history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [inKindDisbursement, setInKindDisbursement] = useState([
        { organizationName: 'Figgers foundation', programName: 'Think Tank1', inKindGifts: 'F-Buds', promisedQty: 1300, disbursedQty: 1300, pendingQty: 10000, rate: 50, estimatedAmount: 50000, Date: 'Oct 01, 2023' },
        { organizationName: 'Figgers foundation', programName: 'Think Tank2', inKindGifts: 'F-Buds', promisedQty: 1300, disbursedQty: 1300, pendingQty: 10000, rate: 50, estimatedAmount: 50000, Date: 'Oct 01, 2023' },
        { organizationName: 'Figgers foundation', programName: 'Think Tank3', inKindGifts: 'F-Buds', promisedQty: 1300, disbursedQty: 1300, pendingQty: 10000, rate: 50, estimatedAmount: 50000, Date: 'Oct 01, 2023' },
        { organizationName: 'Figgers foundation', programName: 'Think Tank4', inKindGifts: 'F-Buds', promisedQty: 1300, disbursedQty: 1300, pendingQty: 10000, rate: 50, estimatedAmount: 50000, Date: 'Oct 01, 2023' }



    ]);

    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState((prevState) => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback,
        }));
    };



    const handleSuccessClose = (message) => {
        handleDataRefresh()
        showMessage("Success", message, "success", 3000);
        closeCashDisbursement()
        loadAllCollection()
    }

    const donationStatusBoxes = [
        {
            value: 'In-Kind Promised Qty',
            transactionStatus: 'Promised',
            numbers: '00',
            // icon: DisbursementIcon,
        },
        {
            value: 'In-Kind Disbursed Qty',
            transactionStatus: 'Disbursed',
            numbers: '00',
            //  icon: DisbursementIcon,
        },
    ]
    const getHeaderCount = (status) => {
        var count = 0;
        if (status == 'Promised') {
            count = inKindDisbursement?.filter(t => t.transactionStatus == 'Promised').length
        } else if (status == 'Disbursed') {
            count = inKindDisbursement?.filter(t => t.transactionStatus == 'Disbursed').length
        }
        return count;
    }

    const [searchFilter, setValue] = useState('');
    const handleSearch = (e) => {
        const currValue = e.target.value;
        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleDataRefresh()
        }
    }
    const [isApproveClick, setIsApproveClick] = useState(false)
    const [isAuthorizationClick, setIsAuthorizationClick] = useState(false);

    const [InKindDisbursementId, setInKindDisbursementId] = useState();
    const [disbursementDetail, setDisbursementDetail] = useState(false);

    const handleActionClick = (key, item) => {
        if (key == 'Details') {
            setDisbursementDetail(true)
            setInKindDisbursementId(item.inKindDisbursementId)
        }
        else if (key == 'delete') {
            deleteItem(item.inKindDisbursementId)
        }
        else {
            return ''
        }
    }
    const closeClick = () => {
        setIsAuthorizationClick(false);
        setIsApproveClick(false);

    };

    const [addNewInKindDisbursement, setAddNewInKindDisbursement] = useState(false
    );

    const addInKindDisburs = () => {

        setAddNewInKindDisbursement(true);
    };
    const closeCashDisbursement = () => {
        setAddNewInKindDisbursement(false);
    };

   const handleClearInput = (name) => {
        setValue('');
        handleDataRefresh();
    };
    const [isDataRefresh, setIsDataRefresh] = useState(false);

    const handleDataRefresh = () => {
        setIsDataRefresh(prev => !prev);
    };

    const [disbursedData, setDisbursedData] = useState([]);


    const loadAllCollection = () => {
        var params = {
        }
        PostDataAPI("fdngrantinkinddisbursement/loadGrid", params).then((result) => {
            console.log(result);
            if (result.success && result.data != null) {
                setDisbursedData(result.data)
                handleDataRefresh()
            } else {
                setDisbursedData([]);
            }
        });
    };


    const deleteItem = (id) => {
        let obj = {
            InKindDisbursementId: id
        }
        showActionDialog(
            "Are you sure you want to delete this record?",
            "confirm",
            function () {
                setIsLoading(true);

                PostDataAPI("fdngrantinkinddisbursement/delete", obj).then((result) => {
                    if (result.success) {
                        showMessage("Success", "Disbursement deleted successfully", "success", 3000);
                        loadAllCollection();
                        handleDataRefresh()
                    } else {
                        showMessage("Error", result.message, "error", 3000);
                    }
                    setIsLoading(false);
                });
            }
        );
    };


    useEffect(() => {
        loadAllCollection()
    }, []);
    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            {disbursementDetail ? <DisbursementDetail InKindDisbursementId={InKindDisbursementId} /> :

                <div>

                    <Grid container >
                        <div className={classes.gridHeader}>

                            <Typography variant="h5" color="initial" className={'HeaderText'}>
                                In-kind Disbursement List
                            </Typography>
                            <div className={classes.SearchSec}>
                                <div item className={classes.gridActions}>
                                    <Button className={classes.changeBtn} onClick={() => addInKindDisburs()}>Add New</Button>
                                </div>

                                <div itemclassName={classes.gridActions}>
                                    <InputBase
                                        value={searchFilter}
                                        placeholder="Search"
                                        className="grid-search-input"
                                        startAdornment={<SearchIcon />}
                                        onChange={handleSearch}
                                        endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                                    />

                                </div>
                            </div>

                        </div>
                    </Grid>


                    <Grid row className={classes.container}>
                        <SearchGrid
                            columns="inKindDisbursement"
                            list={disbursedData}
                            filter={searchFilter}
                            noRecordMsg="No record exists."
                            Icon={true}
                            isUpdate={isDataRefresh}
                            isSearchAble={false}
                            onActionClick={handleActionClick}
                        />
                    </Grid>
                </div>}

            {addNewInKindDisbursement ? (
                <AddDisbursement
                    isOpen={addInKindDisburs}
                    handleClose={closeCashDisbursement}
                    handleSuccessClose={handleSuccessClose}
                //   editProgram={editData} // Conditionally pass EditProgram
                ></AddDisbursement>
            ) : (
                ""
            )}

            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />


            {isAuthorizationClick ? (
                <Authorization
                    dialogOpenClose={handleActionClick}
                    handleClose={closeClick}
                // handleSuccessClose={handleSuccessClose}
                ></Authorization>
            ) : (
                ""
            )}
        </>
    )
}
export default withSnackbar(Payment);